module.exports = __webpack_public_path__ + "assets/widget.77e67dbf.svg";